module.exports = __webpack_public_path__ + "img/gongxingbu.78c221ce.png";